var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguageicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3417",
    "data-name": "Group 3417",
    transform: "translate(-773.238 -3025.643)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_318",
    "data-name": "Ellipse 318",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    transform: "translate(773.238 3025.643)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3419",
    "data-name": "Group 3419",
    transform: "translate(780.805 3040.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4764",
    "data-name": "Path 4764",
    d: "M-524.919,283.832c.881,0,1.783.009,2.683-.005a.708.708,0,0,1,.658.311,2.825,2.825,0,0,0,2.669,1.117,11.353,11.353,0,0,1-1.507,2.976,12.732,12.732,0,0,1-11.049,5.7,13,13,0,0,1-12.622-11.209,13.022,13.022,0,0,1,10.363-14.628,12.827,12.827,0,0,1,8.845,1.378.51.51,0,0,1,.3.7,6.522,6.522,0,0,0-.165,1.056c-.041.339-.063.68-.1,1.054l-1.984-1.135-.067.07c.051.122.108.241.151.365.422,1.214.862,2.422,1.247,3.648.1.3.205.437.5.382a1.074,1.074,0,0,1,1.338.781,10.6,10.6,0,0,0,.99,1.57h-2.25Zm-2.511-5.849H-534.9a2.366,2.366,0,0,0-.087.319,21.2,21.2,0,0,0-.01,5.162c.04.342.222.373.5.372,2.224-.008,4.448,0,6.672-.006.12,0,.24-.019.385-.032A19.419,19.419,0,0,0-527.43,277.984Zm-14.01,5.814h4.007V277.99h-4.013A10.346,10.346,0,0,0-541.44,283.8Zm6.928-8.215h6.662a9.865,9.865,0,0,0-1.9-4.385c-1.142-1.328-1.734-1.321-2.875.014A10.054,10.054,0,0,0-534.512,275.582Zm6.67,10.63h-6.664c.056.237.1.449.155.657a8.81,8.81,0,0,0,2.056,4.062c.841.836,1.383.843,2.216.014A9.621,9.621,0,0,0-527.842,286.212Zm-7.745-15.008a10.64,10.64,0,0,0-4.835,4.4c1.162,0,2.212.006,3.261-.011.092,0,.232-.145.265-.249C-536.45,273.965-536.02,272.58-535.588,271.2Zm13.643,14.987c-1.144,0-2.2-.008-3.246.013-.1,0-.236.166-.272.281-.122.383-.179.788-.311,1.167-.339.973-.706,1.936-1.082,2.959A10.582,10.582,0,0,0-521.945,286.192Zm-18.472,0a10.553,10.553,0,0,0,4.826,4.374c-.434-1.38-.86-2.752-1.3-4.117a.43.43,0,0,0-.309-.245C-538.244,286.184-539.284,286.191-540.417,286.191Z",
    transform: "translate(544.214 -264.795)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4765",
    "data-name": "Path 4765",
    d: "M-305.35,235.321q1.915,0,3.83,0a7.286,7.286,0,0,1,7.346,6.031,7.292,7.292,0,0,1-5.753,8.441,11.44,11.44,0,0,1-1.857.15c-2.117.018-4.235.014-6.353,0a.642.642,0,0,0-.654.384,7.86,7.86,0,0,1-3.677,3.449,1,1,0,0,1-1.281-.15.966.966,0,0,1-.02-1.285,4.849,4.849,0,0,0,.668-3.177.763.763,0,0,0-.306-.461,7.245,7.245,0,0,1-3.228-6.374,7.193,7.193,0,0,1,6.341-6.9c1.636-.142,3.3-.024,4.944-.024Zm-5.317,5.779a1.53,1.53,0,0,0-1.543,1.532,1.575,1.575,0,0,0,1.534,1.56,1.58,1.58,0,0,0,1.569-1.574A1.537,1.537,0,0,0-310.667,241.1Zm12.169,1.555a1.505,1.505,0,0,0-1.509-1.555,1.539,1.539,0,0,0-1.584,1.542,1.581,1.581,0,0,0,1.549,1.549A1.538,1.538,0,0,0-298.5,242.655Zm-6.835-1.555a1.54,1.54,0,0,0-1.573,1.509,1.59,1.59,0,0,0,1.565,1.584,1.55,1.55,0,0,0,1.533-1.551A1.512,1.512,0,0,0-305.332,241.1Z",
    transform: "translate(337.908 -235.321)",
    fill: "#febaba"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageicon);
export default __webpack_public_path__ + "static/media/languageicon.fa2073fcd79aee4fdacd8308376da6b1.svg";
export { ForwardRef as ReactComponent };